import { whenNot } from 'platform/shared/health-apps';
import {
  collectMedicareInformation,
  isShortFormEligible,
} from '../../../utils/helpers';
import medicaid from './medicaid';
import medicare from './medicare';
import medicarePartAEffectiveDate from './medicarePartAEffectiveDate';
import overview from './overview';
import healthInsurancePolicyPages from './policies';
import vaFacility from './vaFacility';

export const insurancePages = {
  medicaid: {
    path: 'insurance-information/medicaid',
    title: 'Medicaid coverage',
    ...medicaid,
  },
  medicare: {
    path: 'insurance-information/medicare',
    title: 'Medicare coverage',
    depends: whenNot(isShortFormEligible),
    ...medicare,
  },
  medicarePartAEffectiveDate: {
    path: 'insurance-information/medicare-part-a-effective-date',
    title: 'Medicare Part A effective date',
    depends: collectMedicareInformation,
    ...medicarePartAEffectiveDate,
  },
  insuranceOverview: {
    path: 'insurance-information/your-health-insurance',
    title: 'Your health insurance',
    ...overview,
  },
  ...healthInsurancePolicyPages,
  vaFacility: {
    path: 'insurance-information/va-facility',
    title: 'VA Facility',
    ...vaFacility,
  },
};
